import { render, staticRenderFns } from "./DpaNavigation.vue?vue&type=template&id=2d601460&"
import script from "./DpaNavigation.vue?vue&type=script&lang=ts&"
export * from "./DpaNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports